// CONST VALUES
const DAYS = [
    { value: "0", label: "Sunday" },
    { value: "1", label: "Monday" },
    { value: "2", label: "Tuesday" },
    { value: "3", label: "Wednesday" },
    { value: "4", label: "Thursday" },
    { value: "5", label: "Friday" },
    { value: "6", label: "Saturday" },
]



const tidy_date = (date) => {
    // if (!date?.includes("Z")) {
    //     date = date + "Z"
    // }

    // Convert From Unix Timestamp

    if (!isNaN(date)) {
        let seconds = date
        date = new Date(date * 1000)
    }

    let day = new Date(date).getDate()
    let month = new Date(date).getMonth() + 1
    let year = new Date(date).getFullYear()
    let hour = new Date(date).getHours()
    let minute = new Date(date).getMinutes()

    if (day < 10) {
        day = "0" + day
    }

    if (month < 10) {
        month = "0" + month
    }

    if (hour < 10) {
        hour = "0" + hour
    }

    if (minute < 10) {
        minute = "0" + minute
    }

    const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    return `${day} ${MONTHS[month - 1]} ${year} ${hour}:${minute}`
}



const tidy_date_raw = (date) => {
    // if (!date?.includes("Z")) {
    //     date = date + "Z"
    // }

    // Convert From Unix Timestamp

    if (!isNaN(date)) {
        let seconds = date
        date = new Date(date * 1000)
    }

    let day = new Date(date).getDate()
    let month = new Date(date).getMonth() + 1
    let year = new Date(date).getFullYear()
    let hour = new Date(date).getHours()
    let minute = new Date(date).getMinutes()

    const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    if (day < 10) {
        day = "0" + day
    }

    if (month < 10) {
        month = "0" + month
    }

    if (hour < 10) {
        hour = "0" + hour
    }

    if (minute < 10) {
        minute = "0" + minute
    }

    return {
        day: day,
        month: MONTHS[month - 1],
        year: year,
        hour: hour,
        minute: minute
    }

}

const currency = (amount) => {
    amount = Math.round((amount) * 100) / 100

    if (amount.toString().includes(".")) {
        amount = amount.toFixed(2)
    }

    // add commas
    amount = amount.toLocaleString()

    return amount
}

const isMobile = (width) => {
    if (width < 700) {
        return true
    } else {
        return false
    }
}

const get_age_by_date = (date) => {
    let today = new Date()
    let birthDate = new Date(date)
    let age = today.getFullYear() - birthDate.getFullYear()
    let m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }
    return age
}

const captialise_first_letter = (string) => {
    if (!string) return ""
    return string.charAt(0).toUpperCase() + string.slice(1)
}

const tidy_frequency_name = (frequency) => {
    // Count the number of days, weeks, or months
    let frequencyName = ""
    if (frequency === "1") {
        frequencyName = "Day"
    } else if (frequency === "7") {
        frequencyName = "Week"
    } else if (frequency === "30") {
        frequencyName = "Month"
    } else {
        frequencyName = "Custom"
    }
    return `${frequency} ${frequencyName}`
}

const tidy_time_difference = (date) => {
    let date_now = new Date()
    date = new Date(date)
    let timeDiff = Math.abs(date_now - date)
    let seconds = Math.floor(timeDiff / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)
    let days = Math.floor(hours / 24)
    let months = Math.floor(days / 30)
    let years = Math.floor(months / 12)

    if (years > 0) {
        return `${years} years ago`
    } else if (months > 0) {
        return `${months} months ago`
    } else if (days > 0) {
        return `${days} days ago`
    } else if (hours > 0) {
        return `${hours} hours ago`
    } else if (minutes > 0) {
        return `${minutes} minutes ago`
    } else {
        return `Just now`
    }
}


const get_mobile_os = () => {
    var userAgent = navigator.userAgent
    console.log(`User Agent: ${userAgent}`)

    // Android detection
    if (/android/i.test(userAgent)) {
        return "android"
    }

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios"
    }

    // Windows detection
    if (/Windows NT/i.test(userAgent)) {
        return "windows"
    }

    // MacOS detection
    if (/Macintosh|Mac OS X/i.test(userAgent)) {
        return "macos"
    }

    // Linux detection
    if (/Linux/i.test(userAgent)) {
        return "linux"
    }
}

const user_has_permissions = (configData, required = []) => {
    if (!Array.isArray(required) || required.length === 0) return true;      // nothing required
    if (!configData?.permissions) return false;                        // no perms loaded
    // console.log({ perms: configData.permissions, required })
    return required.some(key => configData.permissions.includes(key)); // overlap check
};



module.exports = {
    tidy_date,
    tidy_date_raw,
    currency,
    isMobile,
    get_age_by_date,
    captialise_first_letter,
    tidy_frequency_name,
    DAYS,
    get_mobile_os,
    tidy_time_difference,
    user_has_permissions
}
